module.exports = __webpack_public_path__ + "img/view3d-notice-3-light.171ce051.png";